import ResponsiveTable from '../ReusableComponents/ResponsiveTable';
import React from 'react';
import { ACTIONS, MODULES, PROCESS_MODULES, VIEW_ONLY_MODULES } from '../../permissions';

export default function PermissionMatrix({ value, onChange }) {
  const hasFullAccess = MODULES.every(([module]) => ACTIONS.every(([action]) => !!value[module]?.[action]));
  const changeFullAccess = checked => onChange(Object.fromEntries(MODULES.map(([module]) => [module, {
    view: checked, create: checked, edit: checked, delete: checked,
  }])));
  const change = (module, action, checked) => {
    const next = { ...value, [module]: { ...value[module], [action]: checked } };
    if (action === 'view' && !checked) {
      next[module] = { view: false, create: false, edit: false, delete: false };
      if (module === 'processo_seletivo') PROCESS_MODULES.forEach(key => {
        next[key] = { view: false, create: false, edit: false, delete: false };
      });
    }
    if (action !== 'view' && checked) next[module].view = true;
    onChange(next);
  };
  return <div className="table-responsive margin-bottom">
    <label className="form-label">Permissões por módulo</label>
    <div className="form-check mb-2">
      <input className="form-check-input" id="member-full-access" type="checkbox"
        checked={hasFullAccess} onChange={e => changeFullAccess(e.target.checked)} />
      <label className="form-check-label" htmlFor="member-full-access">
        Acesso a tudo (sem restrições)
      </label>
    </div>
    <ResponsiveTable className="table table-bordered table-sm">
      <thead><tr><th scope="col">Módulo</th>{ACTIONS.map(([action, label]) => <th scope="col" key={action}>{label}</th>)}</tr></thead>
      <tbody>{MODULES.map(([module, label]) => {
        const disabled = PROCESS_MODULES.includes(module) && !value.processo_seletivo?.view;
        return <tr key={module}><th scope="row">{label}</th>{ACTIONS.map(([action, title]) =>
          <td key={action}>{VIEW_ONLY_MODULES.includes(module) && action !== 'view' ? '—' : <input type="checkbox" aria-label={`${title} ${label}`}
            checked={!!value[module]?.[action]} disabled={disabled || (action !== 'view' && !value[module]?.view)}
            onChange={e => change(module, action, e.target.checked)} />}</td>
        )}</tr>;
      })}</tbody>
    </ResponsiveTable>
    <small>Selecione ao menos um módulo ou Acesso a tudo. Diagramações seguem as permissões de Provas. As abas dentro de um processo, inclusive Questionários vinculados, exigem também acesso a Processo Seletivo.</small>
  </div>;
}
